module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_praise_example.aaa6dfb5.png";